import React from "react";

function DominancePlanIcon() {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 23.9945C0 10.7427 10.7427 0 23.9945 0C37.2464 0 47.9891 10.7427 47.9891 23.9945C47.9891 37.2464 37.2464 47.9891 23.9945 47.9891C10.7427 47.9891 0 37.2464 0 23.9945Z"
        fill="#F1F5F9"
      />
      <path
        d="M23.5471 15.2625C23.5902 15.1841 23.6536 15.1188 23.7306 15.0733C23.8077 15.0277 23.8955 15.0037 23.985 15.0037C24.0744 15.0037 24.1623 15.0277 24.2393 15.0733C24.3163 15.1188 24.3797 15.1841 24.4229 15.2625L27.3742 20.8652C27.4446 20.995 27.5428 21.1075 27.6618 21.1948C27.7809 21.282 27.9177 21.3419 28.0626 21.37C28.2075 21.3981 28.3569 21.3937 28.4999 21.3573C28.6429 21.3209 28.7761 21.2532 28.8899 21.1592L33.1659 17.496C33.248 17.4292 33.3491 17.3902 33.4548 17.3846C33.5604 17.379 33.6651 17.4071 33.7538 17.4648C33.8425 17.5224 33.9106 17.6068 33.9484 17.7056C33.9861 17.8045 33.9914 17.9128 33.9637 18.0149L31.1303 28.2586C31.0725 28.4682 30.9479 28.6532 30.7754 28.7856C30.603 28.9181 30.392 28.9906 30.1746 28.9924H17.7964C17.5788 28.9909 17.3676 28.9184 17.1949 28.7859C17.0222 28.6535 16.8975 28.4683 16.8396 28.2586L14.0072 18.0159C13.9795 17.9138 13.9849 17.8055 14.0226 17.7066C14.0603 17.6078 14.1284 17.5234 14.2171 17.4658C14.3058 17.4081 14.4105 17.38 14.5162 17.3856C14.6218 17.3912 14.723 17.4302 14.8051 17.497L19.0801 21.1602C19.1939 21.2542 19.327 21.3219 19.4701 21.3583C19.6131 21.3947 19.7624 21.3991 19.9073 21.371C20.0522 21.3429 20.1891 21.283 20.3081 21.1958C20.4271 21.1085 20.5254 20.996 20.5957 20.8662L23.5471 15.2625Z"
        stroke="#45556C"
        strokeWidth="1.99954"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.9868 32.9925H30.9836"
        stroke="#45556C"
        strokeWidth="1.99954"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default DominancePlanIcon;
